/**
 * @file Show/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const DEFAULT_POLICY_SHOW = "DISPLAY_POLICY_LISTING";

export const HIDDEN_A11Y_HEADER_SECTIONS = ["radio"];

// This is number of cards that should show in sidebar on "sports/olympics"
export const OLYMPICS_LIST_COUNT = 3;
const BBiC = "Being Black In Canada";
// Custom heading for the Show component
export const LIST_HEADING = {
    "sports/podcasts": "Sports Podcasts",
    "sports/podcasts/hnic": "Hockey Night in Canada Podcast",
    "sports/podcasts/players-own-voice": "Player's Own Voice Podcast",
    "sports/olympics/road-to-the-olympic-games": "Road to the Olympic Games",
    "books/beingblackincanada": BBiC,
    "arts/beingblackincanada": BBiC,
    "sports/beingblackincanada": BBiC,
    "news/canada/beingblackincanada/all": BBiC,
    "news/covid-19/coping-with-covid-19": "Topic: Coping with COVID",
    "news/covid-19/fact-check": "Topic: Fact Check",
    "news/covid-19/economy-and-finance": "Topic: Economy and Finance",
    "news/covid-19/stories-of-hope": "Topic: Stories of Hope",
    "news/covid-19/lives-remembered": "Topic: Lives Remembered",
    "news/covid-19/international-news": "Topic: International News",
};
